import React, { useEffect, useRef, useState } from "react";
import "../../assets/css/IndependenceDayLoader.css";
import $ from "jquery";

function IndependenceDayLoader() {
  const canvasRef = useRef(null);
  const [title, setTitle] = useState("");

  useEffect(() => {
    const independenceMessages = [
      "Happy Independence Day",
      "15th August - Jai Hind",
      "Proud to be Indian",
      "Freedom in Every Heart",
      "Vande Mataram",
    ];
    const message =
      independenceMessages[Math.floor(Math.random() * independenceMessages.length)];
    let index = 0;

    $("body").css("overflow", "hidden");

    const typing = setInterval(() => {
      if (index < message.length) {
        setTitle((prev) => prev + message[index]);
        index += 1;
      } else {
        clearInterval(typing);
      }
    }, 95);

    return () => clearInterval(typing);
  }, []);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    let animationFrame;
    let particles = [];

    const colors = ["#ff9933", "#ffffff", "#138808", "#0a3d91"];

    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };

    class Petal {
      constructor() {
        this.x = Math.random() * canvas.width;
        this.y = -30;
        this.size = Math.random() * 9 + 5;
        this.speed = Math.random() * 1.8 + 0.8;
        this.swing = Math.random() * 1.4 + 0.4;
        this.angle = Math.random() * Math.PI * 2;
        this.color = colors[Math.floor(Math.random() * colors.length)];
      }

      update() {
        this.y += this.speed;
        this.angle += 0.035;
        this.x += Math.sin(this.angle) * this.swing;
      }

      draw() {
        ctx.save();
        ctx.translate(this.x, this.y);
        ctx.rotate(this.angle);
        ctx.beginPath();
        ctx.ellipse(0, 0, this.size * 0.55, this.size, 0, 0, Math.PI * 2);
        ctx.fillStyle = this.color;
        ctx.globalAlpha = this.color === "#ffffff" ? 0.9 : 0.78;
        ctx.fill();
        ctx.restore();
      }
    }

    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      if (particles.length < 90 && Math.random() < 0.45) {
        particles.push(new Petal());
      }

      particles.forEach((particle) => {
        particle.update();
        particle.draw();
      });

      particles = particles.filter((particle) => particle.y < canvas.height + 40);
      animationFrame = requestAnimationFrame(animate);
    };

    resizeCanvas();
    animate();
    window.addEventListener("resize", resizeCanvas);

    return () => {
      cancelAnimationFrame(animationFrame);
      window.removeEventListener("resize", resizeCanvas);
    };
  }, []);

  return (
    <div className="independence-loader">
      <canvas ref={canvasRef} className="independence-petals" />

      <div className="independence-stage">
        <div className="independence-flag" aria-hidden="true">
          <span className="flag-band flag-saffron"></span>
          <span className="flag-band flag-white">
            <span className="independence-chakra">
              {Array.from({ length: 24 }).map((_, index) => (
                <i key={index} style={{ transform: `rotate(${index * 15}deg)` }} />
              ))}
            </span>
          </span>
          <span className="flag-band flag-green"></span>
        </div>

        <div className="independence-copy">
          <p className="independence-date">15th August</p>
          <h1>{title}</h1>
          <p className="independence-line">
            Proud to build for a free and fearless India
          </p>
        </div>
      </div>
    </div>
  );
}

export default IndependenceDayLoader;
